import { fade, makeStyles } from '@material-ui/core/styles'

export const formStyles = makeStyles((theme) => ({
  formWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%',
    '&.formOnDialog': {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    '&.filter-code-form': {
      [theme.breakpoints.down('sm')]: {
        width: 'calc(100vw - 138px)'
      },
      width: 830
    },
    '& .MuiAlert-root, & .MuiCollapse-container': {
      width: '100%'
    },
    '& .MuiCollapse-wrapperInner': {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      width: '100%',
      '& > div:not($FormItem)': {
        width: '100%'
      }
    }
  },
  invoiceDirectionWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightSemiBold,
    lineHeight: 1.7,
    '& svg': {
      marginRight: theme.spacing(0.5),
      marginTop: theme.spacing(-0.25)
    }
  },
  flipOrder: {},
  noWidth: {},
  AddressInfoWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    width: '100%'
  },
  FormAccordion: {
    width: '100%',
    marginTop: `${theme.spacing(1.5)}px !important`,
    marginBottom: theme.spacing(1)
  },
  SingleRow: {},
  column: {},
  FormItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap'
    },
    [theme.breakpoints.up('md')]: {
      width: '47%'
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.light,
      lineHeight: 1.3,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginLeft: theme.spacing(1),
        cursor: 'pointer',
        transition: 'all 0.5s ease-in-out',
        '&:hover, &:focus': {
          color: theme.palette.text.primary
        }
      }
      // [theme.breakpoints.down('xs')]: {
      //   width: '100%'
      // },
      // [theme.breakpoints.up('sm')]: {
      //   margin: 0,
      //   minHeight: 40,
      //   marginTop: theme.spacing(1),
      //   marginBottom: theme.spacing(0.5),
      //   display: 'flex',
      //   alignItems: 'center',
      //   paddingRight: theme.spacing(2),
      //   '&:not($noWidth)': {
      //     minWidth: '26%'
      //   }
      // }
    },
    '&$SingleRow': {
      flexDirection: 'row',
      '& .MuiInputLabel-root': {
        width: 'auto',
        [theme.breakpoints.down('xs')]: {
          width: '100%'
        },
        [theme.breakpoints.up('sm')]: {
          margin: 0,
          minHeight: 40,
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(0.5),
          display: 'flex',
          alignItems: 'center',
          paddingRight: theme.spacing(2),
          '&:not($noWidth)': {
            minWidth: '26%'
          }
        }
      }
    },
    '& .MuiOutlinedInput-root': {
      // borderBottomRightRadius: 0,
      // borderTopRightRadius: 0
    },
    '& .MuiFormControl-root, & .MuiAutocomplete-root': {
      flex: '1 1 auto',
      width: '100%',
      [theme.breakpoints.down('xs')]: {
        width: '100%'
      },
      '& .MuiInputBase-root.Mui-disabled': {
        backgroundColor: fade(theme.palette.primary.light, 0.1)
      },

      '&.has-downshift .MuiInputBase-formControl': {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        '& input': {
          flex: '1 1 100px'
        },
        '& .MuiChip-root': {
          margin: theme.spacing(0.75, 0.25, 0.5),
          height: 28
        }
      }
    },
    '&:not($column) .MuiFormGroup-root[role="radiogroup"]': {
      flexDirection: 'row',
      '&$flipOrder': {
        flexDirection: 'row-reverse',
        justifyContent: 'flex-end'
      },
      '& .MuiFormControlLabel-root': {
        marginBottom: theme.spacing(0)
      }
    },
    '& a:not(.normal)': {
      display: 'block',
      width: '100%',
      textAlign: 'right'
    },
    '&.info': {
      '& .info-data': {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0.5)
      }
    }
  },
  autoCompleteWrapper: {
    flex: '1 1 auto',
    marginTop: theme.spacing(1),
    width: '100%',
    '& .MuiAutocomplete-inputRoot': {
      paddingTop: `${theme.spacing(0.25)}px !important`,
      paddingBottom: `${theme.spacing(0.25)}px !important`
    },
    '&.has-search': {
      '& .MuiOutlinedInput-root': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    }
  },
  FormTotals: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'flex-end',
    '& $FormItem': {
      flexDirection: 'row',
      [theme.breakpoints.up('md')]: {
        width: '60%'
      },
      '& .MuiInputLabel-root': {
        color: theme.palette.text.light,
        [theme.breakpoints.down('xs')]: {
          width: '100%'
        },
        [theme.breakpoints.up('sm')]: {
          margin: 0,
          minHeight: 40,
          width: 'auto',
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(0.5),
          display: 'flex',
          alignItems: 'center',
          paddingRight: theme.spacing(2),
          '&:not($noWidth)': {
            minWidth: '40%'
          }
        }
      }
    }
  },
  FormInner: {
    justifyContent: 'center',
    '& $FormItem': {
      [theme.breakpoints.up('md')]: {
        width: '95%'
      }
    }
  },
  FormRowList: {
    backgroundColor: theme.palette.colors.offWhite,
    marginTop: theme.spacing(3),
    padding: theme.spacing(2)
  },
  FormListHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1),
    '& .MuiButton-root svg': {
      marginRight: theme.spacing(1)
    },
    '&.inline': {
      flexDirection: 'column',
      alignItems: 'stretch',
      padding: theme.spacing(0),
      '& > .MuiBox-root': {
        padding: theme.spacing(0)
      }
    }
  },
  EntityListContainer: {
    width: '100%',
    padding: theme.spacing(2, 1),
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    minHeight: 50
  },
  ItemHeadingWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  EntityActionsWrapper: {
    display: 'flex'
  },
  ItemHeading: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: theme.spacing(0),
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(30)
    }
  },
  EntityInfoWrapper: {
    width: '100%',
    flexWrap: 'wrap',
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
    marginBottom: theme.spacing(2),
    '&.center': {
      justifyContent: 'center'
    },
    '&.noBottomGutter': {
      marginBottom: theme.spacing(0)
    }
  },
  infoItemWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    // fontSize: theme.typography.pxToRem(16),
    padding: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      '&:nth-of-type(2n+1)': {
        backgroundColor: theme.palette.colors.table
      }
    },
    [theme.breakpoints.up('md')]: {
      '&:nth-of-type(4n+1),&:nth-of-type(4n+2)': {
        backgroundColor: theme.palette.colors.table
      }
    }
  },
  infoItemLabel: {
    fontWeight: theme.typography.fontWeightBold,
    paddingRight: theme.spacing(2)
  },
  EntityInfoContainer: {
    width: '100%'
  },
  addNewEntityButton: {
    float: theme.direction === 'ltr' ? 'right' : 'left',
    textTransform: 'none',
    '& .MuiButton-label': {
      display: 'flex',
      alignItems: 'flex-end'
    }
  },
  getLinkWrapper: {
    '& textarea': {
      fontSize: theme.typography.pxToRem(19),
      lineHeight: 1.3,
      color: theme.palette.text.secondary
    }
  },
  getLinkButtonsWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    '& a': {
      color: theme.palette.common.white + '!important'
    },
    '& .MuiButtonBase-root': {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      textTransform: 'none',
      '& svg': {
        marginRight: theme.spacing(1)
      }

    }
  },
  hint: {
    marginTop: theme.spacing(1)
  },
  alert: {
    marginBottom: theme.spacing(2),
    width: '100%'
  },

  linkBtn: {
    textTransform: 'none',
    transition: 'all 0.3s ease-in-out',
    fontSize: theme.typography.pxToRem(16),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    '&:hover, &:focus': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent'

    }
  },
  fullWidthHint: {
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    '& p': {
      lineHeight: 1.2
    }
  },

  FormCheck: {
    marginTop: theme.spacing(2),
    flexWrap: 'wrap'
  },
  SelectItemWithTitle: {
    display: 'flex',
    flexDirection: 'column',
    '& .title': {
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 1.4
    },
    '& .description': {
      marginTop: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(14),
      whiteSpace: 'normal'
    }
  },
  FormRowPreLine: {
    whiteSpace: 'pre-line'
  },
  FormUpload: {
    justifyContent: 'center',
    '& $FormItem': {
      [theme.breakpoints.up('md')]: {
        width: '100%'
      },
      '& .MuiInputLabel-root': {
        [theme.breakpoints.up('sm')]: {
          minWidth: '36%'
        }
      }
    },
    '&.single-upload $FormItem': {
      '& .MuiInputLabel-root': {
        [theme.breakpoints.up('sm')]: {
          minWidth: '31%'
        }
      }
    }
  },
  FormItemSelect: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    '& .MuiSelect-select svg': {
      verticalAlign: 'middle'
    }
  },
  valignMiddle: {
    verticalAlign: 'middle'
  },
  FormSmall: {
    [theme.breakpoints.up('md')]: {
      width: '24%'
    }
  },
  FormLarge: {
    [theme.breakpoints.up('md')]: {
      width: '72%'
    }
  },
  FormLargeHeight: {
    '& $FormItemSelect .MuiOutlinedInput-root': {
      [theme.breakpoints.up('md')]: {
        height: 52
      }
    }
  },
  FormRow: {
    width: '100%'
  },
  FormLicenseNumberRow: {
    justifyContent: 'center'
  },
  FormLettersControls: {
    '& .MuiFormControl-root': {
      minWidth: 100,
      marginRight: theme.spacing(2)
    }
  },
  FormNumbersWrapper: {
    width: 150,
    flexGrow: '0 !important',
    '&.onlyNumbers': {
      width: 200
    },
    '& .MuiFormControl-marginDense': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0)
    }
  },
  PhoneInputWrapper: {
    direction: 'rtl',
    textAlign: 'right',
    flex: '1 1 auto',
    // width: '100%',
    '& .react-tel-input': {
      fontFamily: 'inherit',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5)
    },
    '& p': {
      whiteSpace: 'pre-line'
    },
    // '& .flag-dropdown': {
    //   display: 'none'
    // },
    '& .react-tel-input .form-control': {
      width: '100%',
      paddingTop: theme.spacing(1.325),
      paddingBottom: theme.spacing(1.125),
      paddingRight: theme.spacing(5.625),
      '&[disabled]': {
        cursor: 'pointer',
        pointerEvents: 'none'
        // backgroundColor: theme.palette.colors.body
      },
      '&:focus': {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 1px ${theme.palette.primary.main}`
      }
    },
    '& .country-list': {
      direction: 'ltr',
      textAlign: 'left',

      '& .search': {
        paddingLeft: theme.spacing(1.25)
      },
      '& .search-box': {
        marginLeft: theme.spacing(1)
      },
      '& .country-name': {
        marginRight: theme.spacing(1)
      },
      '& .dial-code': {
        direction: 'rtl',
        textAlign: 'right',
        display: 'inline-block'
      }
    }
  },

  FormLetterOption: {
    [theme.breakpoints.up('sm')]: {
      minHeight: 40
    },
    '&.flex-between': {
      justifyContent: 'space-between'
    }
  },
  DeleteWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'pre-line',
    '& p': {
      textAlign: 'center',
      fontSize: theme.typography.pxToRem(18),
      marginTop: theme.spacing(2)
    }
  },
  DeleteWarningIcon: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(80),
    color: theme.palette.warning.main
  },


  FormSubmitRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: theme.spacing(5),
    '&.between': {
      justifyContent: 'space-between'
    },
    '&.center': {
      justifyContent: 'center'
    },
    '& button': {
      borderRadius: theme.spacing(1),
      textTransform: 'none',
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.pxToRem(18),
      '&:not(.btn-menu)': {
        padding: theme.spacing(1.5, 3),
        minWidth: 220,
        '&.cancel': {
          minWidth: 0
        }
      },
      '&.btn-menu svg': {
        marginLeft: theme.spacing(0)
      },
      '& svg': {
        marginLeft: theme.spacing(1),
        left: 0,
        position: 'relative',
        transition: 'all 0.3s ease-in-out',
        '&:not(.save)': {
          fontSize: theme.typography.pxToRem(16)
        }
      },
      '&:hover, &:focus': {
        '& svg:not(.save)': {
          left: 10
        }
      },
      '&$InvoiceStepGoBack': {
        '& svg': {
          marginLeft: theme.spacing(0),
          marginRight: theme.spacing(1)
        },
        '&:hover, &:focus': {
          '& svg': {
            left: '-10px !important'
          }
        }
      },

      '& + button': {
        marginLeft: theme.spacing(2.5)
      }

    },
    '&.filter-submit': {
      paddingTop: theme.spacing(1),
      '& button': {
        '&:not(.btn-menu)': {
          padding: theme.spacing(0.75, 2),
          minWidth: 0,
          fontSize: theme.typography.pxToRem(16)
        }
      }
    }
  },
  filterCodeForm: {
    backgroundColor: theme.palette.colors.body
  },
  InvoiceStepGoBack: {},
  fileUploadWrapper: {
    position: 'relative',
    width: '100%',
    height: 40,
    boxShadow: `0px 0px 5px 2px ${fade(theme.palette.colors.border2, 0.2)}`,
    borderRadius: theme.spacing(0.75),

    '&:after': {
      content: 'attr(data-text)',
      fontSize: theme.typography.pxToRem(14),
      position: 'absolute',
      top: 0,
      left: 0,
      background: theme.palette.common.white,
      padding: theme.spacing(1.25, 2),
      display: 'block',
      width: 'calc(100% - 65px)',
      pointerEvents: 'none',
      zIndex: 20,
      height: 40,
      lineHeight: theme.typography.pxToRem(18),
      color: '#999',
      borderRadius: theme.spacing(0.625, 1.25, 1.25, 0.625),
      fontWeight: theme.typography.fontWeightRegular,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    },
    '&:before': {
      content: `${theme.direction === 'ltr' ? '\'Upload\'' : '\'إرفاق\''}`,
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'inline-block',
      height: 40,
      transition: 'all 0.3s ease-in-out',
      background: theme.palette.primary.main,
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightBold,
      zIndex: 25,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(38),
      padding: theme.spacing(0, 3),
      textTransform: 'uppercase',
      pointerEvents: 'none',
      borderRadius: theme.spacing(0, 0.625, 0.625, 0)
    },

    '&:hover': {
      '&:before': {
        background: theme.palette.primary.dark
      }
    },
    '& input': {
      opacity: 0,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 99,
      height: 40,
      margin: 0,
      padding: 0,
      display: 'block',
      cursor: 'pointer',
      width: '100%'
    }
  },
  uploadProgressWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000
  },
  uploadProgress: {
    width: 200,
    height: 10,
    marginTop: theme.spacing(10),
    borderRadius: theme.spacing(1),
    '& .MuiLinearProgress-bar': {
      borderRadius: theme.spacing(1)
    }
  },
  linksList: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0),
    '& a': {
      textDecoration: 'none'
    }
  },
  gutterTop: {
    marginTop: theme.spacing(1.5)
  },
  paymentMethodWrapper: {
    alignItems: 'center',
    '& > button': {
      fontSize: theme.typography.pxToRem(28)
    }
  },
  paymentMethod: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    },
    '& > button': {
      fontSize: theme.typography.pxToRem(51.2),
      padding: theme.spacing(1.5, 8),
      // border: '1px solid rgba(208, 162, 44, 0.5)'
      background:
        `linear-gradient( 136deg, ${fade(theme.palette.primary.main, 0.1)} 0%,${fade(theme.palette.primary.main, 0.1)} 50%,${fade(theme.palette.primary.main, 1)} 50%, ${fade(theme.palette.primary.dark, 1)} 100%)`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: '250% 100%',
      backgroundPosition: '0 0',
      borderColor: fade(theme.palette.primary.main, 0.5),
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      color: theme.palette.text.primary,
      position: 'relative',
      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(40)
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(32),
        '&:not(:first-child)': {
          marginTop: -1,
          borderTopRightRadius: 0,
          borderTopLeftRadius: 0,
          borderLeftColor: fade(theme.palette.primary.main, 0.5),
          marginLeft: 0
        },
        '&:not(:last-child)': {
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0
        }
      },
      '& svg': {
        transition: 'all 0.3s ease-in-out',
        color: fade(theme.palette.common.black, 0.28),
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1)
      },
      '&.Mui-selected, &:hover': {
        flip: false, // opt-out of conversion for a specific rule-set
        backgroundPosition: '100%',
        color: theme.palette.common.white,
        '& svg': {
          color: theme.palette.secondary.main
        }
      }
    },
    '& > label:not(:last-child)': {
      marginRight: theme.spacing(4)
    },
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(32)
    },
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(40)
    }
  },
  confirmBankChange: {
    fontSize: theme.typography.pxToRem(20)
  },
  paymentFormWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    maxHeight: '100%',
    position: 'relative',
    overflowY: 'auto'
  },
  fileDownloadWrapper: {
    marginTop: theme.spacing(0.75)
  },
  addressAccordion: {
    marginTop: theme.spacing(1) + 'px !important',
    marginBottom: theme.spacing(0.5) + 'px !important',
    '&.work': {
      marginTop: theme.spacing(2) + 'px !important'
    },
    '& #ownerHomeAddress-content, & #ownerWorkAddress-content': {
      width: '100%'
    }
  },
  addressAccordionHeading: {
    '&.MuiAccordionSummary-root': {
      minHeight: theme.spacing(6),
      backgroundColor: theme.palette.colors.body
    },
    '& .MuiAccordionSummary-content': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  addressAccordionHeader: {
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      marginRight: theme.spacing(0.75),
      color: theme.palette.primary.main
    }
  },
  addressSmallItem: {},
  addressLargeItem: {},
  addressItemsWrapper: {
    display: 'flex',
    paddingLeft: theme.spacing(0),
    // alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap'
    },
    '.formOnDialog &': {
      flexWrap: 'wrap'
    },
    '& > .MuiFormControl-root': {
      flex: '1 1 auto',
      width: '100%',
      marginLeft: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        width: '35%'
      },
      [theme.breakpoints.up('lg')]: {
        width: '100%',
        '.formOnDialog &': {
          width: '35%'
        }
      },
      '&$addressSmallItem': {
        width: 95,
        minWidth: 95
      }
    },
    '&.work-address': {
      flexWrap: 'wrap',
      '& > .MuiFormControl-root:not($addressSmallItem)': {
        [theme.breakpoints.up('sm')]: {
          '&$addressLargeItem': {
            width: '100%'
          }
        },
        [theme.breakpoints.up('md')]: {
          width: '31%',
          '&$addressLargeItem': {
            width: '45%'
          },
          '.formOnDialog &': {
            width: '35%',
            '&$addressLargeItem': {
              width: '100%'
            }
          }
        }
      }
    }
  },
  addressSelect: {
    marginTop: theme.spacing(1),
    '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
      flip: false,
      transform: 'translate(-14px, 12px) scale(1)'
    },
    '& .MuiOutlinedInput-marginDense': {
      // marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0.5)
    }
  },
  marTop1: {
    marginTop: theme.spacing(1)
  },
  optionWrapper: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  optionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    marginLeft: theme.spacing(0.5)
  },
  optionParent: {
    color: theme.palette.grey['500'],
    fontWeight: theme.typography.fontWeightSemiBold
  },
  option: {
    color: theme.palette.common.black
  },
  optionID: {
    color: theme.palette.primary.dark,
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5)
  },
  createEGSLinkWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& svg': {
      marginRight: theme.spacing(0.5)
    }
  },
  modifyLink: {
    padding: theme.spacing(0),
    display: 'inline',
    textTransform: 'none',
    transition: 'all 0.3s ease-in-out',
    backgroundColor: 'transparent !important',
    fontWeight: theme.typography.fontWeightSemiBold,
    '&:hover': {
      color: theme.palette.secondary.main
    }
  },
  removeLinkedCodeLink: {
    textTransform: 'none',
    marginLeft: theme.spacing(1),
    padding: theme.spacing(0.375, 0.75)
  },
  RequestHeading: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    margin: theme.spacing(0),
    fontSize: theme.typography.pxToRem(20),
    color: theme.palette.primary.main,
    '& svg': {
      marginRight: theme.spacing(1),
      fontSize: theme.typography.pxToRem(30)
    }
  },
  codeStatus: {
    '&.active': {
      color: theme.palette.success.main
    },
    '&.not-active': {
      color: theme.palette.error.main
    }
  },
  category: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(0.25),
    wordBreak: 'break-word',
    '& svg': {
      marginRight: theme.spacing(0.25),
      fontSize: theme.typography.pxToRem(20)
    },
    '&.level2': {
      marginLeft: theme.spacing(0.25)
    },
    '&.level3': {
      marginLeft: theme.spacing(2.25)
    },
    '&.level4': {
      marginLeft: theme.spacing(4.25)
    }
  },
  hintWrapper: {
    whiteSpace: 'pre-wrap'
  },
  templateDownload: {
    textTransform: 'none',
    width: 'auto',
    padding: theme.spacing(0.125),
    textDecoration: 'underline',
    '&:hover, &:focus': {
      backgroundColor: 'transparent'
    }
  },
  codeBulkList: {
    marginTop: theme.spacing(0),
    paddingLeft: theme.spacing(2),
    '& li': {
      marginBottom: theme.spacing(1)
    }
  },
  alertSpacing: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),

    '& .MuiAlertTitle-root': {
      fontSize: theme.typography.pxToRem(18)
    },
    '& .MuiAlert-message': {
      fontSize: theme.typography.pxToRem(16)
    }
  },
  alertButtonWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& button': {
      textTransform: 'none'
    }
  },
  filterCodeFormReset: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightSemiBold,
    textTransform: 'capitalize',
    marginTop: 1,
    marginLeft: theme.spacing(0.5),
    zIndex: 5,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5),
      marginTop: theme.spacing(1.25)
    }
  },
  filterCodeWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    '& .rltv': {
      width: '100%'
    }
  },
  filterCodeFormSearch: {
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightSemiBold,
    height: 52,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    '&.small':{
      height: 43,
    }
  }
}))
